(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5687],{

/***/ 43687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OX": function() { return /* binding */ getProductListApi; },
/* harmony export */   "PT": function() { return /* binding */ getProductTrendsListApi; },
/* harmony export */   "Pj": function() { return /* binding */ getProductFilterApi; },
/* harmony export */   "ZX": function() { return /* binding */ getProductLiveListApi; },
/* harmony export */   "c$": function() { return /* binding */ getProductCategoryApi; },
/* harmony export */   "wV": function() { return /* binding */ getSimilarProductApi; },
/* harmony export */   "zK": function() { return /* binding */ getProductSitemapApi; }
/* harmony export */ });
/* unused harmony exports postImageSearchByImageApi, getProductTrends */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84425);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


// 以图搜图
const postImageSearchByImageApi = params => {
  const formData = new FormData();
  console.log('params.image入参', params); // 确保image是File对象

  if (!(params.image instanceof File)) {
    console.error('传入的image不是File对象:', params.image);
    throw new Error('image必须是File对象');
  }

  formData.append('image', params.image);
  formData.append('keyword', params.keyword || '');
  return request.post(`/data/search/product-image`, formData);
};
const getProductListApi = (params, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products`, _objectSpread({
    params
  }, config));
};
const getProductFilterApi = config => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/filters`, config);
}; // 获取商品的直播列表信息

const getProductLiveListApi = async (id, params) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/${id}/lives`, {
    params,
    skipCodeCheck: true
  });
}; // 获取商品商品分类接口

const getProductCategoryApi = async config => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/product-category`, config);
};
const getSimilarProductApi = async (id, params) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/${id}/similar`, {
    params,
    skipCodeCheck: true
  });
}; // 获取商品商品分类接口

const getProductSitemapApi = async (params, config) => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`/data/products/sitemap/list`, _objectSpread({
    params
  }, config));
}; // 获取销售趋势

const getProductTrends = async id => {
  return request.get(`/data/products/trends/${id}`, {
    skipCodeCheck: true
  });
}; // 获取销售趋势列表

const getProductTrendsListApi = async params => {
  return _api_request__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .ZP.get(`data/products/list/trends`, {
    params,
    skipCodeCheck: true
  });
};

/***/ }),

/***/ 97588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



const useIsMobile = () => {
  var _window;

  const {
    isMobile
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.ssr);

  if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF && (_window = window) !== null && _window !== void 0 && _window.navigator.userAgent) {
    var _window2;

    return (0,_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq)((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.navigator.userAgent);
  }

  return isMobile;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);

/***/ }),

/***/ 18357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hp": function() { return /* binding */ useBreadcrumbs; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var antd_mobile_es_components_spin_loading__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(87492);
/* harmony import */ var antd_mobile_es_components_side_bar__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(25314);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(97607);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(90652);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83435);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26638);
/* harmony import */ var _api_request__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84425);
/* harmony import */ var _utils_getServerSidePropsCatch__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17648);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(42586);
/* harmony import */ var _api_product__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43687);
/* harmony import */ var _hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3770);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96638);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42170);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25617);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);




















const useBreadcrumbs = _ref => {
  let {
    currentCategoryObj,
    currentRegionObj
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  return [{
    name: t['menu.platform.home'],
    href: '/'
  }, {
    name: t['seo.sitemap.product_breadcrumb'],
    href: '/products'
  }, {
    name: currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name,
    href: `/sitemap/products/${(0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getCategoryString */ .n7)(currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug)}/1`
  }, {
    name: currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name,
    href: ''
  }];
};

const ProductsSitemap = _ref2 => {
  var _product_categories$, _dataFromSSR$meta, _dataFromSSR$meta2;

  let {
    filtersFromSSR,
    dataFromSSR
  } = _ref2;
  const {
    product_categories
  } = filtersFromSSR || {};
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const {
    0: activeCategoryId,
    1: setActiveCategoryId
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((_product_categories$ = product_categories[0]) === null || _product_categories$ === void 0 ? void 0 : _product_categories$.id);
  const {
    0: dataList,
    1: setDataList
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((dataFromSSR === null || dataFromSSR === void 0 ? void 0 : dataFromSSR.data) || []);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  const {
    0: loading,
    1: setLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const {
    region
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(state => state.ssr);
  const {
    regionOptions
  } = (0,_hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
  const [pageObj, setPageObj] = (0,ahooks__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
    total: ((_dataFromSSR$meta = dataFromSSR.meta) === null || _dataFromSSR$meta === void 0 ? void 0 : _dataFromSSR$meta.total) || 0,
    pageSize: ((_dataFromSSR$meta2 = dataFromSSR.meta) === null || _dataFromSSR$meta2 === void 0 ? void 0 : _dataFromSSR$meta2.per_page) || 200
  });
  const originRegionObj = regionOptions.find(r => r.region === region);
  const currentUrlCategory = router.query.products_category;
  const currentUrlPage = router.query.page || '1';
  const currentCategoryObj = product_categories.find(c => c.id === activeCategoryId);
  const currentCategoryNameSlug = currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug;
  const {
    0: currentRegionObj,
    1: setCurrentRegionObj
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(originRegionObj);
  const breadcrumbs = useBreadcrumbs({
    currentRegionObj,
    currentCategoryObj
  });
  const {
    urlCategoryNameSlug,
    urlRegion
  } = (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getUrlField */ .nT)(currentUrlCategory);
  const footerList = (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .useFooterLinks */ .T2)({
    category: (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '',
    region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || ''
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(() => {
    if (urlCategoryNameSlug && urlRegion) {
      var _product_categories$f;

      const curActiveCategoryId = (_product_categories$f = product_categories.find(c => c.name_slug === urlCategoryNameSlug)) === null || _product_categories$f === void 0 ? void 0 : _product_categories$f.id;
      curActiveCategoryId && setActiveCategoryId(curActiveCategoryId);
      const curReginObj = regionOptions.find(r => r.nameSlug === urlRegion);
      curReginObj && setCurrentRegionObj(curReginObj);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const fetchList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async params => {
    setLoading(true);
    (0,_api_product__WEBPACK_IMPORTED_MODULE_7__/* .getProductSitemapApi */ .zK)(params).then(res => {
      if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .SUCCESS_CODE */ .Gh) {
        var _res$data$meta, _res$data$meta2;

        setDataList(res.data.data || []);
        setPageObj({
          total: (_res$data$meta = res.data.meta) === null || _res$data$meta === void 0 ? void 0 : _res$data$meta.total,
          pageSize: (_res$data$meta2 = res.data.meta) === null || _res$data$meta2 === void 0 ? void 0 : _res$data$meta2.per_page
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [setPageObj]);
  (0,ahooks__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(() => {
    fetchList({
      category_id: activeCategoryId,
      page: currentUrlPage,
      region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region) || ''
    });
  }, [activeCategoryId, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region, currentUrlPage, fetchList]);

  const handleReginClick = item => {
    setCurrentRegionObj(item);
    router.replace({
      pathname: router.basePath,
      query: {
        products_category: (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getCategoryString */ .n7)(currentCategoryNameSlug, item.nameSlug),
        page: '1'
      }
    }, undefined, {
      scroll: false,
      shallow: true
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().productsSitemap),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
        children: breadcrumbs.map((item, index) => {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Item */ .Z.Item, {
            href: item.href,
            children: item.name
          }, index);
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("h1", {
      style: {
        color: '#0f1219'
      },
      children: t['seo.sitemap.product_h1'].replace('{category}', currentCategoryNameSlug || '').replace('{regionName}', (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || '')
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().side),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(antd_mobile_es_components_side_bar__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          activeKey: activeCategoryId,
          onChange: key => {
            setActiveCategoryId(key);
          },
          children: product_categories.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(antd_mobile_es_components_side_bar__WEBPACK_IMPORTED_MODULE_18__/* ["default"].Item */ .Z.Item, {
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
              href: {
                pathname: router.pathname,
                query: {
                  products_category: (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getCategoryString */ .n7)(item.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                  page: '1'
                }
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
                children: item.name
              })
            })
          }, item.id))
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().main),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().regionWrap),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().regionLabel),
            children: t['common.region']
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().regionList),
            children: regionOptions.map(option => {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_10___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().regionItem), {
                  [(_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().selectedRegion)]: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region) === option.region
                }),
                onClick: () => handleReginClick(option),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                  href: {
                    pathname: router.pathname,
                    query: {
                      products_category: (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getCategoryString */ .n7)(currentCategoryNameSlug, option === null || option === void 0 ? void 0 : option.nameSlug),
                      page: '1'
                    }
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
                    style: {
                      pointerEvents: 'none'
                    },
                    children: option.name
                  })
                })
              }, option.region);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().productsSitemapList),
          children: loading ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(antd_mobile_es_components_spin_loading__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}) : dataList.map((item, index) => {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .ProductItem */ .Cd, {
              item: item
            }, index);
          })
        }), !loading && dataList.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          style: {
            display: 'flex',
            justifyContent: 'center'
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
            total: pageObj.total,
            pageSize: pageObj.pageSize,
            current: currentUrlPage ? +currentUrlPage : 1,
            itemRender: (page, type, originElement) => {
              if (type === 'page') {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                  href: {
                    pathname: router.pathname,
                    query: {
                      products_category: (0,_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_11__/* .getCategoryString */ .n7)(currentCategoryNameSlug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                      page: `${page}`
                    }
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
                    children: page
                  })
                });
              }

              return originElement;
            }
          })
        }) : null]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      children: footerList.map(item => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          color: "primary",
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_16___default().tagSpan),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            href: item.href,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
              children: item.name
            })
          })
        }, item.name);
      })
    })]
  });
};

const getServerSideProps = _store__WEBPACK_IMPORTED_MODULE_4__/* .wrapper.getServerSideProps */ .YS.getServerSideProps(store => async context => {
  try {
    var _product_categories$2;

    const ssrCtx = (0,_api_request__WEBPACK_IMPORTED_MODULE_5__/* .generateSsrCtx */ ._8)(store.getState());
    const [filters] = await Promise.all([(0,_api_product__WEBPACK_IMPORTED_MODULE_7__/* .getProductFilterApi */ .Pj)({
      ssrCtx
    }).then(_api_request__WEBPACK_IMPORTED_MODULE_5__/* .backendCodeProcessor */ .KA)]);
    const {
      product_categories
    } = filters || {};
    const data = await (0,_api_product__WEBPACK_IMPORTED_MODULE_7__/* .getProductSitemapApi */ .zK)({
      category_id: (_product_categories$2 = product_categories[0]) === null || _product_categories$2 === void 0 ? void 0 : _product_categories$2.id,
      page: context.query.page || '1'
    }, {
      ssrCtx
    }).then(res => {
      if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .SUCCESS_CODE */ .Gh) {
        return res.data;
      }
    });
    return {
      props: {
        filtersFromSSR: filters,
        dataFromSSR: data
      }
    };
  } catch (error) {
    return (0,_utils_getServerSidePropsCatch__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error);
  }
});
/* harmony default export */ __webpack_exports__["ZP"] = (ProductsSitemap);

/***/ }),

/***/ 18491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ ProductItem; },
/* harmony export */   "T2": function() { return /* binding */ useFooterLinks; },
/* harmony export */   "YX": function() { return /* binding */ RegionList; },
/* harmony export */   "n7": function() { return /* binding */ getCategoryString; },
/* harmony export */   "nT": function() { return /* binding */ getUrlField; },
/* harmony export */   "qo": function() { return /* binding */ FooterLinks; }
/* harmony export */ });
/* unused harmony export DYNAMIC_PRODUCT_CATEGORY */
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64080);
/* harmony import */ var _index_module_less__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_index_module_less__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(28096);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64606);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6277);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(77303);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(97607);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(36097);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(90652);
/* harmony import */ var _mobile_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18357);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83126);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(42586);
/* harmony import */ var _api_product__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43687);
/* harmony import */ var _hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3770);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96638);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(42170);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25617);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















const MenuItem = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"].Item */ .Z.Item;
const Sider = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Sider */ .Z.Sider;
const Header = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Header */ .Z.Header;
const Footer = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Footer */ .Z.Footer;
const Content = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Content */ .Z.Content;
const DYNAMIC_PRODUCT_CATEGORY = `best-selling-{category}-products-in-{regionName}-on-tiktok`;
const REGEX = /best-selling-(.+?)-products-in-(.+?)-on-tiktok/;
const getCategoryString = function () {
  let currentCategoryNameSlug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let currentRegion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return DYNAMIC_PRODUCT_CATEGORY.replace('{category}', currentCategoryNameSlug || '').replace('{regionName}', currentRegion);
};
const getUrlField = str => {
  const match = str.match(REGEX);

  if (match) {
    const urlCategoryNameSlug = match[1];
    const urlRegion = match[2];
    return {
      urlCategoryNameSlug: urlCategoryNameSlug,
      urlRegion: urlRegion
    };
  } else {
    return {};
  }
};
const RegionList = _ref => {
  let {
    onClick,
    currentCategoryNameSlug,
    renderItem,
    currentRegionObj,
    categoryKey = 'products_category'
  } = _ref;
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const {
    regionOptions
  } = (0,_hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().regionWrap),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().regionLabel),
      children: t['common.region']
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().regionList),
      children: regionOptions.map(option => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_9___default()((_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().regionItem), {
            [(_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().selectedRegion)]: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region) === option.region
          }),
          onClick: () => onClick(option),
          children: renderItem ? renderItem : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: {
              pathname: router.pathname,
              query: {
                [categoryKey]: getCategoryString(currentCategoryNameSlug, option.nameSlug),
                page: '1'
              }
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
              style: {
                pointerEvents: 'none'
              },
              children: option.name
            })
          })
        }, option.region);
      })
    })]
  });
};
const ProductItem = _ref2 => {
  let {
    item
  } = _ref2;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().listItem),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
      href: `/products/${item.product_id}`,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().mb6),
          style: {
            fontWeight: 700,
            color: '#403d5a',
            wordBreak: 'break-all'
          },
          children: item.product_name
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().mb6),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
        children: [t['seo.sitemap.shop'], ":", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
          href: `/shops/${item.seller_id}`,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
            children: item.seller_name
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("span", {
        className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().ml10),
        children: [t['common.region'], ": ", item.region.name]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        color: "#EBECFF",
        defaultChecked: true,
        style: {
          color: '#655AEC'
        },
        size: "small",
        children: item.category
      })
    })]
  });
};
const useFooterLinks = _ref3 => {
  let {
    category,
    region
  } = _ref3;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const curCategory = category.toLowerCase() === 'all' ? '' : category;
  return [{
    name: t['seo.sitemap.products.tag1'].replace('{category}', curCategory || '').replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.products.tag2'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.products.tag3'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.products.tag4'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.products.tag5'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }, {
    name: t['seo.sitemap.products.tag6'].replace('{category}', curCategory).replace('{region}', region),
    href: '#'
  }];
};
const FooterLinks = _ref4 => {
  let {
    category,
    region,
    useFooterLinks
  } = _ref4;
  const list = useFooterLinks({
    category,
    region
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: `${(_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().listWrap)}`,
    style: {
      paddingBottom: '12px'
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
      size: "medium",
      wrap: true,
      children: list.map(item => {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: item.href,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
              children: item.name
            })
          })
        }, item.name);
      })
    })
  });
};

const ProductSitemap = _ref5 => {
  var _product_categories$, _dataFromSSR$meta, _dataFromSSR$meta2;

  let {
    filtersFromSSR,
    dataFromSSR
  } = _ref5;
  const {
    product_categories
  } = filtersFromSSR || {};
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const {
    0: activeCategoryKey,
    1: setActiveCategoryKey
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(((_product_categories$ = product_categories[0]) === null || _product_categories$ === void 0 ? void 0 : _product_categories$.key) || 'All');
  const {
    0: dataList,
    1: setDataList
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((dataFromSSR === null || dataFromSSR === void 0 ? void 0 : dataFromSSR.data) || []);
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
  const {
    0: loading,
    1: setLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    region
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .useSelector */ .v9)(state => state.ssr);
  const {
    regionOptions
  } = (0,_hooks_useRegionOptions__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  const [pageObj, setPageObj] = (0,ahooks__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
    total: ((_dataFromSSR$meta = dataFromSSR.meta) === null || _dataFromSSR$meta === void 0 ? void 0 : _dataFromSSR$meta.total) || 0,
    pageSize: ((_dataFromSSR$meta2 = dataFromSSR.meta) === null || _dataFromSSR$meta2 === void 0 ? void 0 : _dataFromSSR$meta2.per_page) || 200
  });
  const originRegionObj = regionOptions.find(r => r.region === region);
  const currentUrlCategory = router.query.products_category;
  const currentUrlPage = router.query.page || '1';
  const currentCategoryObj = product_categories.find(c => c.key === activeCategoryKey);
  const currentCategoryNameSlug = currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name_slug;
  const {
    0: currentRegionObj,
    1: setCurrentRegionObj
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(originRegionObj);
  const breadcrumbs = (0,_mobile_pages_sitemap_products__WEBPACK_IMPORTED_MODULE_2__/* .useBreadcrumbs */ .hp)({
    currentCategoryObj,
    currentRegionObj
  });
  const {
    urlCategoryNameSlug,
    urlRegion
  } = getUrlField(currentUrlCategory); // console.log('当前id', activeCategoryKey, currentUrlCategory, currentCategoryNameSlug, regionOptions)

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(() => {
    if (urlCategoryNameSlug && urlRegion) {
      var _product_categories$f;

      const curActiveCategoryKey = (_product_categories$f = product_categories.find(c => c.name_slug === urlCategoryNameSlug)) === null || _product_categories$f === void 0 ? void 0 : _product_categories$f.key;
      curActiveCategoryKey && setActiveCategoryKey(curActiveCategoryKey);
      const curReginObj = regionOptions.find(r => r.nameSlug === urlRegion);
      curReginObj && setCurrentRegionObj(curReginObj);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const fetchList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async params => {
    setLoading(true);
    (0,_api_product__WEBPACK_IMPORTED_MODULE_6__/* .getProductSitemapApi */ .zK)(_objectSpread(_objectSpread({}, params), {}, {
      category_id: params.category_id === '-1' ? '' : params.category_id
    })).then(res => {
      if (res.data.code === _utils_constants__WEBPACK_IMPORTED_MODULE_17__/* .SUCCESS_CODE */ .Gh) {
        var _res$data$meta, _res$data$meta2;

        setDataList(res.data.data || []);
        setPageObj({
          total: (_res$data$meta = res.data.meta) === null || _res$data$meta === void 0 ? void 0 : _res$data$meta.total,
          pageSize: (_res$data$meta2 = res.data.meta) === null || _res$data$meta2 === void 0 ? void 0 : _res$data$meta2.per_page
        });
      }
    }).finally(() => {
      setLoading(false);
    });
  }, [setPageObj]);
  (0,ahooks__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(() => {
    var _product_categories$f2;

    fetchList({
      category_id: ((_product_categories$f2 = product_categories.find(c => c.key === activeCategoryKey)) === null || _product_categories$f2 === void 0 ? void 0 : _product_categories$f2.id) || '',
      page: currentUrlPage,
      region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region) || ''
    });
  }, [activeCategoryKey, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.region, currentUrlPage, fetchList, product_categories]);

  const handleReginClick = item => {
    setCurrentRegionObj(item);
    router.replace({
      pathname: router.basePath,
      query: {
        products_category: getCategoryString(currentCategoryNameSlug, item.nameSlug),
        page: '1'
      }
    }, undefined, {
      scroll: false,
      shallow: true
    });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().productsSitemap),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
      className: "layout-collapse-demo",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(Sider, {
        breakpoint: "xl",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: "logo"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          selectedKeys: [activeCategoryKey],
          onClickMenuItem: key => {
            setActiveCategoryKey(key);
          },
          style: {
            width: '100%'
          },
          className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().menuWrap),
          children: product_categories.map(item => {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(MenuItem, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                href: {
                  pathname: router.pathname,
                  query: {
                    products_category: getCategoryString(item.name_slug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                    page: '1'
                  }
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                  children: item.name
                })
              })
            }, item.key);
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(Header, {
          style: {
            paddingLeft: 20
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h1", {
            children: t['seo.sitemap.product_h1'].replace('{category}', (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '').replace('{regionName}', (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || '')
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          style: {
            padding: '0 24px'
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
              style: {
                margin: '16px 0'
              },
              children: breadcrumbs.map((item, index) => {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Item */ .Z.Item, {
                  href: item.href,
                  children: item.name
                }, index);
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(Content, {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(RegionList, {
              onClick: handleReginClick,
              currentCategoryNameSlug: currentCategoryNameSlug,
              currentRegionObj: currentRegionObj
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
              loading: loading,
              className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().listWrap),
              style: {
                marginBottom: '20px'
              },
              children: [dataList.map((item, index) => {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(ProductItem, {
                  item: item
                }, index);
              }), !loading && dataList.length > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                style: {
                  display: 'flex',
                  justifyContent: 'end'
                },
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                  className: (_index_module_less__WEBPACK_IMPORTED_MODULE_13___default().pageWrap),
                  total: pageObj.total,
                  pageSize: pageObj.pageSize,
                  current: currentUrlPage ? +currentUrlPage : 1,
                  itemRender: (page, type, originElement) => {
                    if (type === 'page') {
                      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: {
                          pathname: router.pathname,
                          query: {
                            products_category: getCategoryString(currentCategoryNameSlug, currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.nameSlug),
                            page: `${page}`
                          }
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                          children: page
                        })
                      });
                    }

                    return originElement;
                  }
                })
              }) : null]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(FooterLinks, {
              category: (currentCategoryObj === null || currentCategoryObj === void 0 ? void 0 : currentCategoryObj.name) || '',
              region: (currentRegionObj === null || currentRegionObj === void 0 ? void 0 : currentRegionObj.name) || '',
              useFooterLinks: useFooterLinks
            })]
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (ProductSitemap);

/***/ }),

/***/ 17648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42586);



const getServerSidePropsCatch = (error, context) => {
  var _error$data6, _error$data6$errors, _error$data7;

  if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
    var _error$response, _context$query;

    const statusCode = String((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status);

    if ((context === null || context === void 0 ? void 0 : (_context$query = context.query) === null || _context$query === void 0 ? void 0 : _context$query.from) === 'monitor') {
      var _error$data, _error$data$errors, _error$data2;

      return {
        props: {
          errorCode: '405',
          message: (error === null || error === void 0 ? void 0 : (_error$data = error.data) === null || _error$data === void 0 ? void 0 : (_error$data$errors = _error$data.errors) === null || _error$data$errors === void 0 ? void 0 : _error$data$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data2 = error.data) === null || _error$data2 === void 0 ? void 0 : _error$data2.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
        }
      };
    }

    if (['403', '404', '500'].includes(statusCode)) {
      var _error$data3, _error$data3$errors, _error$data4;

      return {
        props: {
          errorCode: statusCode,
          message: (error === null || error === void 0 ? void 0 : (_error$data3 = error.data) === null || _error$data3 === void 0 ? void 0 : (_error$data3$errors = _error$data3.errors) === null || _error$data3$errors === void 0 ? void 0 : _error$data3$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data4 = error.data) === null || _error$data4 === void 0 ? void 0 : _error$data4.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
        }
      };
    } else if (statusCode === '401') {
      return {
        redirect: {
          destination: `/login`,
          permanent: false
        }
      };
    }
  } else {
    var _error$data5;

    const code = error === null || error === void 0 ? void 0 : (_error$data5 = error.data) === null || _error$data5 === void 0 ? void 0 : _error$data5.code;

    if ([_constants__WEBPACK_IMPORTED_MODULE_1__/* .NOT_VERIFIED */ .MC].includes(code)) {
      return {
        redirect: {
          destination: '/not-verified',
          permanent: false
        }
      };
    }
  }

  return {
    props: {
      errorCode: '500',
      message: (error === null || error === void 0 ? void 0 : (_error$data6 = error.data) === null || _error$data6 === void 0 ? void 0 : (_error$data6$errors = _error$data6.errors) === null || _error$data6$errors === void 0 ? void 0 : _error$data6$errors.messages) || (error === null || error === void 0 ? void 0 : (_error$data7 = error.data) === null || _error$data7 === void 0 ? void 0 : _error$data7.msg) || (error === null || error === void 0 ? void 0 : error.message) || ''
    }
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getServerSidePropsCatch);

/***/ }),

/***/ 83435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productsSitemap":"index_productsSitemap__2wJeb","productsSitemapList":"index_productsSitemapList__z6yjm","listItem":"index_listItem__DL210","container":"index_container__3Kw99","side":"index_side__M_8CS","main":"index_main__dIQ_R","content":"index_content__BXpoH","active":"index_active__9rp8L","regionList":"index_regionList__FbLRK","regionItem":"index_regionItem__unSwD","regionWrap":"index_regionWrap__S1_cc","regionLabel":"index_regionLabel__yeao_","selectedRegion":"index_selectedRegion__aAnd2","tagSpan":"index_tagSpan__h4ALZ"};

/***/ }),

/***/ 64080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productsSitemap":"index_productsSitemap__3QWR0","menuWrap":"index_menuWrap__KiM6d","pageWrap":"index_pageWrap__aSvXl","regionWrap":"index_regionWrap__rNM9C","sectionCard":"index_sectionCard__MRie8","regionList":"index_regionList__jFWFv","regionLabel":"index_regionLabel__jvuJn","regionItem":"index_regionItem__E0_E0","selectedRegion":"index_selectedRegion__PBRTy","listItem":"index_listItem__9TJ2u","listWrap":"index_listWrap__pQned","mb6":"index_mb6__zJjHy","ml10":"index_ml10__kD2nv"};

/***/ })

}]);